import React, { useState, useEffect, useRef } from 'react';
import { MdOutlineContentCopy } from "react-icons/md";
import './ScheduleVideoMeet.css';
import Loader from '../Loader/Loader';

const ScheduleVideoMeet = ({ meetCode, setShowScheduleVideoMeet, setShowVideoMeetTooltip, isLoader }) => {
  const [showPopup, setShowPopup] = useState(true);
  const [showCopiedPopup, setShowCopiedPopup] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [width, setWidth] = useState('18rem'); 
  const popupRef = useRef(null);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleJoinMeet = () => {
    window.open(`https://meet.google.com/${meetCode}`);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(`https://meet.google.com/${meetCode}`);
    setShowCopiedPopup(true);
    setTimeout(() => setShowCopiedPopup(false), 2000);
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setShowPopup(false);
      setShowScheduleVideoMeet(false);
      setShowVideoMeetTooltip()
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

    // Adjust the width based on meetCode
    useEffect(() => {
      if (meetCode) {
        meetCode.includes('Appointment already') ? setWidth('24rem') : setWidth('18rem'); // width increased by 20%
      }
    }, [meetCode]);


  function formatMeetMessage(meetCode) {
    // Regular expressions to match date and name
    const dateRegex = /\d{2}-[A-Za-z]{3}-\d{4}/;  // Matches the date format (dd-MMM-yyyy)
    const nameRegex = /by\s(.+)\n/;  // Matches the text after 'by' until the newline
  
    // Replace the date and name with bolded versions
    const formattedMessage = meetCode
      .replace(dateRegex, '<b>$&</b>')  // Bold the date
      .replace(nameRegex, 'by <b>$1.</b><br/>\n');  // Bold the name
  
    return formattedMessage;
  }

  return (
    <div>
      {showPopup && (
        <div className="popup-overlay">
          <>
            <div className="video-content" ref={popupRef} style={{ width }}>
              <>{
                isLoader ? <Loader/> : 
                <>
                  {meetCode.includes('Appointment already') ? <div dangerouslySetInnerHTML={{ __html: formatMeetMessage(meetCode)}}/> :
                    <>
                      <p>Meeting invite is sent.</p>
                      <div className="action-buttons">
                        <button className="join-meet-button" onClick={handleJoinMeet}>
                          Join Meet
                        </button>
                        <button
                          className="copy-link-button"
                          onClick={handleCopyLink}
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                        >
                          <MdOutlineContentCopy style={{ fontSize: '25px' }} />
                        </button>
                        {(isHovered && !showCopiedPopup) && <div className="hover-text">Copy meeting link</div>}
                        {showCopiedPopup && <div className="copied-popup">Meet link copied!</div>}
                      </div>
                    </>
                  }
                </>
              }
              </>
            </div>
          </>
        </div>
      )}
    </div>
  );
};

export default ScheduleVideoMeet;